import { useAtomValue } from "jotai";

import { currentUserIsBookingOwnerAtom } from "../../../../../../../../../atoms/selectors/currentUserIsBookingOwnerAtom/currentUserIsBookingOwnerAtom";
import { getRoundFromIdAtom } from "../../../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";

export const useShouldShowSetOwnerMenuOption = (roundId: string) => {
  const round = useAtomValue(getRoundFromIdAtom(roundId));
  const currentUserIsBookingOwner = useAtomValue(currentUserIsBookingOwnerAtom);
  const roundIsMemberOrCustomer =
    round?.player?.clientType === "member" ||
    round?.player?.clientType === "customer";
  const roundIsAlreadyOwner = round?.isOwner;
  const roundHasValidPlayer = !!round?.player.id;
  const shouldShowMenuOption =
    roundHasValidPlayer &&
    !roundIsAlreadyOwner &&
    currentUserIsBookingOwner &&
    roundIsMemberOrCustomer;
  return shouldShowMenuOption;
};
